import { render, staticRenderFns } from "./DealerDetailView.vue?vue&type=template&id=4276e4fc&scoped=true&"
import script from "./DealerDetailView.vue?vue&type=script&lang=js&"
export * from "./DealerDetailView.vue?vue&type=script&lang=js&"
import style0 from "./DealerDetailView.vue?vue&type=style&index=0&id=4276e4fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4276e4fc",
  null
  
)

export default component.exports